import { render, staticRenderFns } from "./courseRecommen.vue?vue&type=template&id=5d8d1eb0"
import script from "./courseRecommen.vue?vue&type=script&lang=js"
export * from "./courseRecommen.vue?vue&type=script&lang=js"
import style0 from "./courseRecommen.vue?vue&type=style&index=0&id=5d8d1eb0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports